import { createContext } from 'react'
import noop from 'lodash/noop'

export type HotelSelectContextValue = {
  isShownButton: boolean
  isShownModal: boolean
  setIsShownModal: (newValue: boolean) => void
  setIsShownButton: (newValue: boolean) => void
}

export default createContext<HotelSelectContextValue>({
  isShownButton: false,
  isShownModal: false,
  setIsShownModal: noop,
  setIsShownButton: noop,
})
